"use client";

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";

interface FactoryOptionsProps {
  options: string[];
}

export default function FactoryOptions({ options }: FactoryOptionsProps) {
  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className="mt-8">
      <Disclosure>
        {({ open }) => (
          <div className="border border-zinc-200 rounded-lg overflow-hidden">
            <DisclosureButton className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-zinc-50 transition-colors">
              <span className="text-sm text-zinc-600">
                Factory Options
              </span>
              <i className={`bootstrap-chevron-down text-xs text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`}></i>
            </DisclosureButton>
            <DisclosurePanel className="px-4 pb-4 bg-zinc-50">
              <div className="flex flex-wrap gap-1.5">
                {options.map((option, index) => (
                  <span key={index} className="px-2 py-0.5 bg-white text-zinc-600 text-xs rounded border border-zinc-200">
                    {option}
                  </span>
                ))}
              </div>
            </DisclosurePanel>
          </div>
        )}
      </Disclosure>
    </div>
  );
}
